 class ProductAccordion extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('dialog').forEach(dialog => {
          const summary = dialog.querySelector('summary');
          if (!summary) return;
 
          summary.addEventListener('click', () => {
            const isOpen = dialog.hasAttribute('open');
 
            
            this.querySelectorAll('dialog[open]').forEach(d => d.removeAttribute('open'));
 
            
            if (!isOpen) dialog.setAttribute('open', '');
          });
        });
      }
    }
 
    customElements.define('product-accordion', ProductAccordion);